module.exports = __webpack_public_path__ + "img/myhd1.1641520899224.png";